import { toCapitalize } from "../../utils/Utils";

export const formatEventTypeLabel = (eventType) =>
  eventType === "CIP" ? "CIP" : toCapitalize(eventType);

export const DURATION_CONFIG = (t, eventType, daysBetweenCIPsRange) => {
  const { min, max } = daysBetweenCIPsRange;
  const formattedEventType = formatEventTypeLabel(eventType);

  const config = {
    CIP: {
      duration_per_event: {
        min: 22,
        max: 360,
        unit: "hrs",
        default: 22,
      },
      duration_between_event: {
        min: min,
        max: max,
        unit: "days",
        default: (min + max) / 2,
      },
    },
    shutdown: {
      duration_per_event: {
        min: 1,
        max: 180,
        unit: "days",
        default: 3,
      },
      duration_between_event: {
        min: 7,
        max: 1825,
        unit: "days",
        default: 360,
      },
    },
  };

  const getField = (key, labelKey) => ({
    key,
    label: t(labelKey, { eventType: formattedEventType }),
    ranges: {
      hard: {
        min: config[eventType][key].min,
        max: config[eventType][key].max,
      },
    },
    unit: config[eventType][key].unit,
    default: config[eventType][key].default,
  });

  return {
    duration_per_event: getField(
      "duration_per_event",
      "CIPEvent.durationPerEvent",
    ),
    duration_between_event: getField(
      "duration_between_event",
      "CIPEvent.durationBtwEvent",
    ),
  };
};

export const ADD_INFO = {
  key: "add_info",
  multiline: "2",
  maxChar: 500,
};
